import React from "react";
import { ProducerSummaryLoaderTemplate } from "themes/common/components/producer";

function ProducerSummaryLoader(props) {
    return <ProducerSummaryLoaderTemplate {...props} />;
}

export default ProducerSummaryLoader;
